export default __webpack_public_path__ + "static/media/shopping.552f5a08.gif";